import { ChangeEvent } from "react";
import { OwSelectOptionContent } from "./OwSelectOptionContent";
import { useIntl } from "react-intl";
import "./OwSelectOption.scss";

type Props = {
    options?: any[];
    filterOptionsFn?: (selectedValue: any) => any[];
    valueProp: string;
    showBlankFirst?: boolean;
    selectedOption?: any;
    selectedOptionProp?: string;
    titleProp: string;
    titlePropTwo?: string;
    titleRenderFn?: (option: any) => string;
    fn: ((e: ChangeEvent<HTMLSelectElement>) => void) | ((e: any) => void);
    name: string;
    isRequired?: boolean;
    isDisabled?: boolean;
    isActive?: boolean;
    isDisabledOnActive?: boolean;
    autoSelectSingleOption?: boolean;
    hasSelectedOptionProp?: boolean;
    emitObject?: boolean;
    emitOnLoad?: boolean;
    emitTarget?: boolean;
    title?: string;
    nullIfBlank?: boolean; // not working?
    translateTitle?: boolean;
    className?: string;
    id?: string;
    sizeClass?: string;
    testId?: string;
};

const OwSelectOption = (props: Props) => {
    const intl = useIntl();

    return (
        <>
            <OwSelectOptionContent {...props} intl={intl} />
        </>
    );
};

export default OwSelectOption;
